export default "__VITE_ASSET__D10qVPYd__"